import { Vue, Component, Watch } from 'vue-property-decorator'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { mixins } from 'vue-class-component'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import { createGood, updateGood, customDealerGoodInfo, adminCustomDealerGoodInfo } from './gql'
import { findGood } from '../GoodsList/gql'
import { statusOptions, statusCodes } from '@/helpers/goods'
import { Goods, GoodsStatus } from '@/interfaces/goods'
import AppFormItem from '@/components/AppFormItem.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppMultiImagesUploader from '@/components/AppMultiImagesUploader.vue'
import WangEditor from 'wangeditor'
import { utcDateTimeToDate, utcDateTimeToLocal } from '@/utils/dateTime'
import FileHandler from '@/mixins/file-handler'
import { TypedGqlError } from '@/interfaces/error'
import * as OSS from 'ali-oss'
import moment from 'moment'
import AuthFilter from '@/mixins/auth-filter'
import { formatCurrency } from '@/utils/currency'

Component.registerHooks([
  'beforeRouteLeave'
])

@Component({
  components: {
    AppBreadcrumbs,
    AppFormItem,
    AppTextField,
    AppSelector,
    AppMultiImagesUploader
  }
})
export default class Editgoods extends mixins(FileHandler, AuthFilter) {
  // 面包屑
  breadcrumbs: Breadcrumb[] = [
    {
      text: '商品管理'
    },
    {
      text: '商品品类',
      to: { name: 'GoodsList' }
    }
  ]

  goods: Goods | null = null
  formatCurrency = formatCurrency

  // 表单
  GoodInput: any = {
    isbn: '',
    title: '',
    subTitle: '',
    press: '',
    publishedDate: '',
    author: '',
    price: '',
    statusIndex: 0,
    details: '',
    createdAt: '',
    thumb: '',
    dealerPrice: '',
    proportion: '',
    coverImages: [],
    deliveryMethod: '每月按期配送到班'

  }

  originInput = ''

  items = ['基本信息', '详情'];

  // 判断新建还是编辑，默认为新建
  isEdit = false

  // 是否从经销商台过来
  isFromDealer = false

  // id
  goodsId = ''

  // 状态
  statusOptions = statusOptions()
  statusCodes = statusCodes()

  // 时间格式
  utcDateTimeToDate = utcDateTimeToDate
  utcDateTimeToLocal = utcDateTimeToLocal

  // 轮播id
  carouselIds = []

  // 编辑器
  editor: any;

  dealer: any

  disabledActions = true

  get hasRight () {
    return this.getRole() !== 'dealer' && !this.isFromDealer
  }

  @Watch('GoodInput', { deep: true })
  goodInputChange (val: any) {
    if (JSON.stringify(val) !== this.originInput) {
      this.disabledActions = false
    } else {
      this.disabledActions = true
    }
  }

  // mounted
  async mounted () {
    // 判断是否为编辑
    const type = sessionStorage.getItem('type')
    if (type) {
      await this.initData(type)
    } else {
      sessionStorage.setItem('type', this.$route.params.type)
      await this.initData(this.$route.params.type)
    }
    const dealerId = sessionStorage.getItem('dealerId')
    const dealer = JSON.parse(sessionStorage.getItem('dealer') + '')
    if (dealerId) {
      this.isFromDealer = true
      this.dealer = dealer
    } else {
      const { dealerId, dealer } = this.$route.params
      if (dealerId) {
        sessionStorage.setItem('dealerId', dealerId)
        this.isFromDealer = true
        this.dealer = JSON.parse(dealer)
        sessionStorage.setItem('dealer', dealer)
      }
    }
    if (this.dealer) {
      this.GoodInput.dealerPrice = formatCurrency(this.dealer.price)
      this.GoodInput.proportion = (this.dealer.sharingProportion || 100) + ''
      this.GoodInput.details = this.dealer.details
      this.originInput = JSON.stringify(this.GoodInput)
    }

    this.initEditor()
  }

  // 初始化数据
  async initData (type: string) {
    if (type === 'new') {
      // 新建
      this.isEdit = false
      this.breadcrumbs.push({ text: '添加品类' })
    } else {
      // 编辑
      this.isEdit = true
      const { id } = this.$route.params
      this.goodsId = id + ''
      await this.getGoodsById()
    }
  }

  // 图片事件
  carouselChangedHandler (value: any) {
    const { urls, ids } = value
    this.GoodInput.coverImages = urls
    this.carouselIds = ids
  }

  // 查询by id
  async getGoodsById () {
    try {
      const result = await this.$apollo.query({
        query: findGood,
        variables: {
          goodId: +this.goodsId
        }
      })
      if (result) {
        this.goods = result.data.findGood
        const { isbn, title, subTitle, author, status, publishedDate, press, price, details, coverImages, deliveryMethod } = result.data.findGood
        const statusIndex = this.statusCodes.findIndex((item) => {
          return item === GoodsStatus[status as GoodsStatus]
        })
        this.GoodInput = {
          isbn: isbn || '',
          title: title || '',
          subTitle: subTitle || '',
          author: author || '',
          statusIndex,
          press: press || '',
          details: details || '',
          price: formatCurrency(price),
          publishedDate: publishedDate ? this.utcDateTimeToDate(publishedDate) : '',
          dealerPrice: '',
          proportion: '',
          coverImages: coverImages || [],
          deliveryMethod: deliveryMethod || ''
        }
        // todo删除富文本编辑器在阿里云上的图片
        this.originInput = JSON.stringify(this.GoodInput)
        this.breadcrumbs = [
          {
            text: '商品管理'
          },
          {
            text: '商品品类',
            to: { name: 'GoodsList' }
          }
        ]
        this.breadcrumbs.push({ text: `${title}` })
      }
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 添加商品request
  async editGoodsRequest () {
    const { isbn, title, statusIndex, price, subTitle, publishedDate, press, author, details, coverImages, deliveryMethod } = this.GoodInput
    const status = GoodsStatus[this.statusCodes[statusIndex]]
    // 新建和修改不同操作
    // todo 图片上传，默认传一张固定的图片
    // thumb是coverImages[0]
    const msg = !this.isEdit ? '添加' : '修改'
    const request = !this.isEdit ? createGood : updateGood
    const input = {
      author,
      coverImages: coverImages,
      details,
      isbn,
      press,
      price: (price || 0) * 100,
      status,
      subTitle,
      thumb: coverImages[0] || '',
      title,
      publishedDate,
      deliveryMethod: deliveryMethod || ''
    }
    let variables: any = {}
    if (this.isEdit) {
      const goodId = +this.goodsId
      variables = { input, goodId }
    } else {
      variables = { input }
    }
    try {
      const result = await this.$apollo.mutate({
        mutation: request,
        variables: {
          ...variables
        }
      })
      if (result) {
        const key = !this.isEdit ? 'createGood' : 'updateGood'
        const { id } = result.data[key]
        this.goodsId = id + ''
        showNotification({
          msg: `${msg}成功！`,
          type: SnackType.Success
        })
        this.isEdit = true
        sessionStorage.setItem('type', 'edit')
        this.disabledActions = true
        this.$router.go(-1)
        // 从阿里云删除富文本编辑器
      } else {
        showNotification({
          msg: `${msg}失败！`,
          type: SnackType.Error
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 确认提交表单
  submitForm () {
    if (this.validateForm('form')) {
      if (this.getRole() === 'dealer') {
        // 经销商
        this.customDealerGoodInfoRequest()
      } else {
        // 管理员
        if (this.isFromDealer) {
          // 管理员修改经销商自定义商品详情
          this.updateDealerGoodsRequest()
        } else {
          // 编辑信息
          this.editGoodsRequest()
        }
      }
    }
  }

  async updateDealerGoodsRequest () {
    const { dealerPrice, proportion, details } = this.GoodInput
    const dealerId = sessionStorage.getItem('dealerId')
    try {
      const result = await this.$apollo.mutate({
        mutation: adminCustomDealerGoodInfo,
        variables: {
          dealerId: +(dealerId + ''),
          goodId: +this.goodsId,
          input: {
            details: details || null,
            price: (dealerPrice || 0) * 100,
            proportion: +proportion
          }
        }
      })
      if (result) {
        showNotification({
          msg: '修改成功！',
          type: SnackType.Success
        })
        this.disabledActions = true
        this.$router.go(-1)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 经销商修改details
  async customDealerGoodInfoRequest () {
    const dealerId = this.me.dealer?.id
    try {
      const result = await this.$apollo.mutate({
        mutation: customDealerGoodInfo,
        variables: {
          dealerId,
          goodId: +this.goodsId,
          input: {
            details: this.GoodInput.details
          }
        }
      })
      if (result) {
        showNotification({
          msg: '修改成功！',
          type: SnackType.Success
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 清空form
  clearForm () {
    this.GoodInput = {
      isbn: '',
      title: '',
      subTitle: '',
      press: '',
      publishedDate: '',
      author: '',
      price: '',
      statusIndex: 0,
      details: '',
      createdAt: '',
      thumb: '',
      coverImages: []
    }
  }

  // 初始化编辑器
  initEditor () {
    const element = this.$refs.editor as any
    const editor = new WangEditor(element)
    editor.config.onchange = (newHtml: any) => {
      this.GoodInput.details = newHtml
    }
    // 最大上传一张图片
    editor.config.uploadImgMaxLength = 1
    editor.config.customUploadImg = (resultFiles: any, insertImgFn: any) => {
      this.uploadEditorImg(resultFiles, insertImgFn)
    }
    // 设置编辑区域高度为 500px
    editor.config.height = 500
    editor.create()
    // todo设置编辑器
    editor.txt.html(this.GoodInput.details || '')
    this.editor = editor
  }

  // 编辑器上传图片
  async uploadEditorImg (files: File[], insertImgFn: any) {
    this.fileToUpload = files[0]
    if (!this.checkCredentialValid()) {
      await this.getOSSCredentials()
    }
    const fileUploaded = await this.uploadEditorOss()
    insertImgFn(fileUploaded)
  }

  async uploadEditorOss () {
    if (!this.stsCredential || !this.fileToUpload) return
    const { accessKeyId, accessKeySecret, stsToken, bucket, region } = this.stsCredential
    const { fileToUpload } = this
    // @ts-ignore
    const client = new OSS({
      region: region,
      accessKeyId: accessKeyId,
      accessKeySecret: accessKeySecret,
      bucket: bucket,
      stsToken: stsToken
    })
    const path = 'goods_details/' + moment().format('YYYY/MM/DD') + moment().unix() + `_${fileToUpload.name}`
    const result = await client.put(path, fileToUpload)
    const ossUrl = (process.env.VUE_APP_OSS_URL?.split('//')[1] ?? '').replace(/\/+$/, '')
    const domainUrl = (process.env.VUE_APP_DOMAIN?.split('//')[1] ?? '').replace(/\/+$/, '')
    const url = this.$R.replace(ossUrl, domainUrl, result.url)
    return url
  }

  // 表单重置验证
  resetValidation (form: string) {
    (
      this.$refs[form] as Vue & { resetValidation: () => void }
    ).resetValidation()
  }

  // 表单验证
  validateForm (form: string) {
    return (this.$refs[form] as Vue & { validate: () => boolean }).validate()
  }

  beforeDestroy () {
    // 编辑的时候上传直接保存到数据库了，删除也会从阿里云删除
    // 新建的时候，图片url上传到阿里云，若没有保存，则自动删除
    if (!this.isEdit) {
      this.GoodInput.coverImages.forEach((url: string) => {
        this.deleteFileFromOSS(url)
      })
    }
    this.editor.destroy()
    this.editor = null
    sessionStorage.removeItem('type')
    sessionStorage.removeItem('dealer')
    sessionStorage.removeItem('dealerId')
    this.resetValidation('form')
  }

  async beforeRouteLeave (to: any, from: any, next: any) {
    if (!this.disabledActions) {
      const res = confirm('页面修改尚未保存，是否确定要离开？')
      next(res)
    } else {
      next()
    }
  }
}
